module.exports = __webpack_public_path__ + "img/Quiet-Cove-005.a62bbe98.jpg";